/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SentenceDirective = zod
	.object({
		case_item_id: zod.string().nullable().describe('Case item ID'),
		directive_id: zod.string().describe('Directive catalog ID'),
		duration_seconds: zod.number().nullable().describe('Duration in seconds'),
		ends_at: zod.iso.datetime({ offset: true }).nullable().describe('When this directive expires'),
		id: zod.string().describe('Directive ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
		lifecycle_status: zod.enum(['pending', 'active', 'served', 'revoked', 'voided']),
		policy_plan_component_id: zod.string().nullable().describe('Directive component ID'),
		policy_plan_id: zod.string().nullable().describe('Policy plan ID'),
		reasoning: zod.string().nullable().describe('AI reasoning for this directive'),
		require_approval: zod.boolean().describe('Whether this directive required approval'),
		revoked_at: zod.iso
			.datetime({ offset: true })
			.nullable()
			.describe('When this directive was revoked'),
		served_at: zod.iso
			.datetime({ offset: true })
			.nullable()
			.describe('When this directive was served'),
		starts_at: zod.iso
			.datetime({ offset: true })
			.nullable()
			.describe('When this directive was activated'),
		updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp'),
		violation_id: zod.string().describe('Violation ID'),
		voided_at: zod.iso
			.datetime({ offset: true })
			.nullable()
			.describe('When this directive was voided')
	})
	.describe('An individual issued directive within a sentence');

export type SentenceDirective = zod.input<typeof SentenceDirective>;
export type SentenceDirectiveOutput = zod.output<typeof SentenceDirective>;
